import {useQuery, useQueryClient} from "@tanstack/react-query";
import {fetchUserCurrent, USER_CURRENT_KEY} from "../api/public-voissa/users";
import createLink from "../libs/createLink";
import ability from "../ability";
import {useNavigate} from "react-router-dom";
import _ from "lodash";
import qs from "qs";
import useLogout from "../hooks/useLogout";

const useQueryCurrentUser = ({
        enabled = false,
        onSuccess = () =>{}
    } = {}) =>{
    const queryClient = useQueryClient();
    const logout = useLogout();
    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const currentRole = _.get(dataCurrentUser, 'role');
    const navigate = useNavigate();

    return useQuery(
        [USER_CURRENT_KEY],
        ()=> fetchUserCurrent(),
        {
            staleTime : (1000 * 60 * 2),
            enabled,
            refetchOnWindowFocus: true,
            onSuccess : async (currentUser) =>{
                let isAlert = sessionStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_alert`);
                onSuccess(currentUser);
                if(currentUser?._id) {
                    window._userId = currentUser._id;
                    if (!currentUser?.subscription?.hasAccess ) {
                        if([2,3].includes(currentUser.profile.gender)){
                            queryClient.setQueryData([USER_CURRENT_KEY], oldData => {
                                return {
                                    ...oldData,
                                    modalSubscribed : {
                                        modal : false,
                                        modalName : "",
                                        link : createLink("userMeSettingsCertification", oldData)
                                    }
                                }
                            });
                        }
                        else{
                            queryClient.setQueryData([USER_CURRENT_KEY], oldData => {
                                return {
                                    ...oldData,
                                    modalSubscribed : {
                                        modal : false,
                                        modalName : "",
                                        link : createLink("subscription")
                                    }
                                }
                            });
                        }
                    }
                    if (currentUser.role !== "emailUnconfirmed" && !currentUser.profile.isCompleted && !isAlert) {
                        let {aToken, actionToken} = qs.parse(window.location.search, {ignoreQueryPrefix: true});
                        if((aToken || actionToken) && window.location.pathname !== '/first-connexion'){
                            sessionStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_alert`, true);
                            navigate(createLink("userMe", currentUser));
                        }
                    }
                }

                if(currentUser?.rules && (!dataCurrentUser || currentRole !== currentUser.role)){
                    ability.update(currentUser.rules);
                }
                queryClient.setQueryData([USER_CURRENT_KEY], oldData => {
                    delete oldData.rules;
                    return oldData
                });
            },
            onError : (error) =>{
                const statusCode = _.get(error, 'statusCode');
                const errorMessage = _.get(error, 'message')
                    || _.get(error, 'data.message')
                    || _.get(error, 'response.data.message');
                if(statusCode === 403 && /banned/i.test(String(errorMessage))){
                    console.log("User banned (403), removing token");
                    logout();
                    return;
                }
                if(_.get(error, 'statusCode') === 404){
                    console.log("Token expired or user not found, redirecting to home");
                    logout();
                }
            }
        }
    );
}

export default useQueryCurrentUser;